module.exports = __webpack_public_path__ + "static/img/gongzuoxitong.414d8fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/gongzuoxitong.png
// module id = WlT9
// module chunks = 1